export default {
  data: function data() {
    return {};
  },
  watch: {},
  methods: {}
};